module.exports = __webpack_public_path__ + "img/about-31.2fd1506f.png";